import { useQuery } from 'react-query';
import { QueryKeys } from '.';
import { useApi } from '../../context';
import { DealRequestAllocationRealEstate } from '../../models';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';

export function useDealRequestAllocationRealEstatesQuery(guid: string | undefined) {
	const api = useApi();

	return useQuery(QueryKeys.AllocationRealEstates(guid), () =>
		AxiosUtils.getResponseData(
			api.get<DealRequestAllocationRealEstate[]>(CerebroApiEndpoints.AllocationRealEstates.Root(guid))
		)
	);
}
